import { useMutation, useQueryClient } from '../lib/queryClient';
import { bulkCreateFiles } from '../endpoints/files/bulk-create_POST.schema';
import { toast } from 'sonner';

export const useBulkCreateFiles = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: bulkCreateFiles,
    onSuccess: (data) => {
      if (data.files.length > 0) {
        const sessionId = data.files[0].sessionId;
        queryClient.invalidateQueries({ queryKey: ['files', 'list', sessionId] });
        queryClient.invalidateQueries({ queryKey: ['sessions', 'detail', sessionId] });
        toast.success(`Successfully imported ${data.files.length} files`);
      } else {
        toast.info('No new files were imported (duplicates skipped)');
      }
    },
    onError: (error) => {
      toast.error(`Failed to import files: ${error.message}`);
    },
  });
};
